import {isNil} from 'ramda';

const DIALOG_SELECTOR = '[role="dialog"]';

/**
 * Tells whether the element belongs to the dialog that currently sits on top of the
 * dialog stack. Buttons rendered outside any dialog (page level, FullScreenModal) are
 * considered covered as soon as a dialog is open, so their global shortcuts must not
 * fire while the user interacts with that dialog.
 *
 * Uses document order of `[role="dialog"]` on purpose — not the managed DialogsProvider
 * stack. Later portaled overlays that also expose `role="dialog"` (DatePicker popper,
 * AI assistant panel) own keyboard focus while open, so suppressing shortcuts behind
 * them is intentional. The managed stack alone would miss those non-managed overlays.
 */
export function getIsElementInTopDialog(element: HTMLElement): boolean {
  if (typeof document === 'undefined') {
    return true;
  }

  const dialogs = document.querySelectorAll<HTMLElement>(DIALOG_SELECTOR);
  const topDialog = dialogs[dialogs.length - 1];

  if (isNil(topDialog)) {
    return true;
  }

  return topDialog.contains(element);
}
